import { render, staticRenderFns } from "./TabNotificationBubble.vue?vue&type=template&id=7f5696d0&scoped=true"
import script from "./TabNotificationBubble.vue?vue&type=script&lang=ts"
export * from "./TabNotificationBubble.vue?vue&type=script&lang=ts"
import style0 from "./TabNotificationBubble.vue?vue&type=style&index=0&id=7f5696d0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5696d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f5696d0')) {
      api.createRecord('7f5696d0', component.options)
    } else {
      api.reload('7f5696d0', component.options)
    }
    module.hot.accept("./TabNotificationBubble.vue?vue&type=template&id=7f5696d0&scoped=true", function () {
      api.rerender('7f5696d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TabNotificationBubble.vue"
export default component.exports